import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d05b506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-cover-container" }
const _hoisted_2 = {
  key: 0,
  class: "custom-cover-preview"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "cover-overlay" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "custom-cover-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {downloadData, postData,} from '@/service/main/system'
import {modalConfig} from './config/modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {ref} from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import {useStore} from '@/store'
import {ElLoading, ElMessage, ElMessageBox} from 'element-plus'
import axios from 'axios'
import localCache from '@/utils/cache'



export default /*#__PURE__*/_defineComponent({
  __name: 'EmpWelcome',
  setup(__props) {

const store = useStore()
const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增'
  modalConfig.formItems.forEach(item => {
    if (item.field === 'empId' || item.field === 'corpId') {
      item.isDisabled = false
    }
  })
}

const editCb = () => {
  modalTitle.value = '编辑'
  modalConfig.formItems.forEach(item => {
    if (item.field === 'empId' || item.field === 'corpId') {
      item.isDisabled = true
    }
  })
}

const handleDownloadImport = () => {
  const fileName = '欢迎语上传模板.xlsx'
  downloadData(
    '/main/welcome/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}
let loadingInstance = ref<any>()
const handleImportProgress = (res: any) => {
  loadingInstance.value = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
const handleImportSuccess = (res: any) => {
  closeLoading()
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    if (res && res.code) {
      ElMessage({
        type: 'warning',
        message: res.message
      })
    } else {
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
      handleSearchClick()
    }
  }
}

const handleImportError = (res: any) => {
  closeLoading()
  ElMessage({
    type: 'error',
    message: res.message
  })
}

// 上传图片
const uploadPic = async (uploadFile: any, scope: any) => {
  try {
    loadingInstance.value = ElLoading.service({
      lock: true,
      text: '上传图片中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    const formData = new FormData()
    formData.append('id', scope.row.id)
    formData.append('file', uploadFile.file)

    const token = localCache.getCache('token')
    const res = await axios.post('/auxiliary/main/welcome/uploadPic', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    })

    if (res.data.code === 200 || res.data.success) {
      closeLoading()
      ElMessage.success('上传成功')
      initData()
    } else {
      ElMessage.error(res.data.message || '上传失败')
    }
  } catch (error) {
    closeLoading()
    console.log(error)
    ElMessage.error('上传失败')
  }
}

// 删除图片
const deletePic = async (row: any) => {
  ElMessageBox.confirm('确认删除图片？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    postData("/main/welcome/deletePic", {id: row.id})
    setTimeout(() => {
      initData()
    }, 1000)
  })
}

// 上传视频
const uploadVideo = async (uploadFile: any, scope: any) => {
  try {
    const maxSize = 10 * 1024 * 1024
    if (uploadFile.file.size > maxSize) {
      ElMessage.error('视频大小不能超过10M')
      return
    }

    loadingInstance.value = ElLoading.service({
      lock: true,
      text: '上传视频中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    const formData = new FormData()
    formData.append('id', scope.row.id)
    formData.append('file', uploadFile.file)

    const token = localCache.getCache('token')
    const res = await axios.post('/auxiliary/main/welcome/uploadVideo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    })

    if (res.data.code === 200 || res.data.success) {
      closeLoading()
      ElMessage.success('上传成功')
      initData()
    } else {
      closeLoading()
      ElMessage.error(res.data.message || '上传失败')
    }
  } catch (error) {
    closeLoading()
    console.log(error)
    ElMessage.error('上传失败')
  }
}

// 删除视频
const deleteVideo = async (row: any) => {
  ElMessageBox.confirm('确认删除视频？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    postData("/main/welcome/deleteVideo", {id: row.id})
    setTimeout(() => {
      initData()
    }, 1000)
  })
}

const getVideoTimeText = (upVideoTime: string) => {
  if (!upVideoTime) return ''

  const uploadDate = new Date(upVideoTime)
  const currentDate = new Date()
  const diffTime = currentDate.getTime() - uploadDate.getTime()
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60))

  if (diffHours >= 72) {
    return '已失效'
  } else {
    const remainingHours = 72 - diffHours
    return `距离失效还剩${remainingHours}小时`
  }
}

const getVideoTimeClass = (upVideoTime: string) => {
  if (!upVideoTime) return ''

  const uploadDate = new Date(upVideoTime)
  const currentDate = new Date()
  const diffTime = currentDate.getTime() - uploadDate.getTime()
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60))

  if (diffHours < 72) {
    return 'video-time-valid'
  } else {
    return 'video-time-invalid'
  }
}

const beforeImgUpload = (rawFile) => {
   if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('图片大小不能超过 2MB ')
    return false
  }
  return true
}

const beforeVideoUpload = (rawFile) => {
  if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error('视频大小不能超过 10MB ')
    return false
  }
  return true
}

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const closeLoading = () => {
  if (loadingInstance.value) {
    loadingInstance.value.close();
  }
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "welcome",
      deleteTip: "确认删除此项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onYbwaveDownloadImport: handleDownloadImport,
      onImportProgress: handleImportProgress,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError
    }, {
      picUrl: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_1, [
          (scope.row.picUrl != null && scope.row.picUrl != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: scope.row.picUrl,
                  alt: _ctx.图片
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "mini",
                    onClick: _withModifiers(($event: any) => (deletePic(scope.row)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_upload, {
                  "http-request": (uploadFile) => uploadPic(uploadFile, scope),
                  "before-upload": beforeImgUpload,
                  accept: "image/*",
                  limit: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode("上传图片")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["http-request"])
              ]))
        ])
      ]),
      videoId: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_6, [
          (scope.row.videoId != null && scope.row.videoId != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "mini",
                  onClick: _withModifiers(($event: any) => (deleteVideo(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除视频")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_el_upload, {
                  "http-request": (uploadFile) => uploadVideo(uploadFile, scope),
                  "before-upload": beforeVideoUpload,
                  accept: "video/*",
                  limit: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode("上传视频")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["http-request"])
              ]))
        ])
      ]),
      upVideoTime: _withCtx((scope) => [
        (scope.row.upVideoTime)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(getVideoTimeClass(scope.row.upVideoTime))
            }, _toDisplayString(getVideoTimeText(scope.row.upVideoTime)), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "welcome",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})